import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import reportWebVitals from './reportWebVitals';
import NotFound from './components/NotFound';
import DoctorProfile from './components/DoctorProfile';
import Services from './components/Services';
import Specialities from './components/Specialities';
import Empanelment from './components/Empanelment';
import Gallery from './components/Gallery';
import Awards from './components/Awards';
import Contact from './components/Contact';
import EyeDiseases from './components/EyeDiseases';
import TestimonialPage from './components/TestimonialPage';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <div> 
      <Routes> 
        <Route path="/" element={<App />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="/DoctorProfile" element={<DoctorProfile />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Specialities" element={<Specialities />} />
        <Route path="/Empanelment" element={<Empanelment />} />
        <Route path="/Gallery" element={<Gallery />} />
        <Route path="/Awards" element={<Awards />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/EyeDiseases" element={<EyeDiseases />} />
        <Route path="/Testimonials" element={<TestimonialPage />} />
      </Routes>
      </div>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
